(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vin-decoder"] && !window.DesignMode) return;
  try {
    

class VinDecoder {
  constructor() {
    const container = document.querySelector('.vin-decoder-container');

    // Read configuration from data attributes
    this.apiToken = container.dataset.apiToken;
    this.customer = null;

    if (container.dataset.customerId) {
      this.customer = {
        id: container.dataset.customerId,
        name: container.dataset.customerName,
        email: container.dataset.customerEmail
      };
    }

    // Build strings object from individual data attributes
    this.strings = {
      searchPartsLabel: container.dataset.searchPartsLabel,
      vehicleDetailsUnavailable: container.dataset.vehicleDetailsUnavailable,
      loadingMessage: container.dataset.loadingMessage,
      errors: {
        invalidVin: container.dataset.errorInvalidVin,
        maxVins: container.dataset.errorMaxVins,
        auth: container.dataset.errorAuth,
        decode: container.dataset.errorDecode,
        unknown: container.dataset.errorUnknown,
        imageSize: container.dataset.errorImageSize
      }
    };

    // Get DOM elements
    this.savedVinsContainer = document.getElementById('saved-vins-container');
    this.savedVinsList = document.getElementById('saved-vins-list');
    this.vinsListWrapper = document.getElementById('vins-list-wrapper');
    this.vinInput = document.getElementById('vin-input');
    this.decodeButton = document.getElementById('decode-vin-button');
    this.errorMessage = document.getElementById('vin-error-message');
    this.loadingMessage = document.getElementById('vin-loading-message');
    this.toggleSavedVinsButton = document.getElementById('toggle-saved-vins');
    this.imageUploadInput = document.getElementById('vehicle-image-upload');
    this.imagePreviewContainer = document.getElementById('image-preview-container');
    this.imagePreview = document.getElementById('image-preview');
    this.removeImageButton = document.getElementById('remove-image');

    // Image data
    this.imageBase64 = null;
    this.MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB

    if (this.customer) {
      this.init();
    }
  }

  async init() {
    try {
      this.loadLocalVins();
      await this.syncWithServer();
      this.setupEventListeners();
      await this.loadSearchFields();
    } catch (error) {
      this.handleError(error);
    }
  }

  async loadSearchFields() {
    try {
      /*
        {
          "body": false,
          "fuel": false,
          "make": true,
          "trim": false,
          "year": false,
          "doors": false,
          "model": false,
          "seats": false,
          "engine": false,
          "driveline": false,
          "horsepower": false,
          "displacement": false
        }
      */
      const searchFields = await fetch('https://vin-decoder.dragos.club/settings/search-fields', {
        headers: {
          'Authorization': `Bearer ${this.apiToken}`
        }
      });

      if (searchFields.ok) {
        const searchFieldsData = await searchFields.json();
        this.searchFields = searchFieldsData;
      } else {
        throw new Error('Failed to fetch search fields');
      }
    } catch (error) {
      console.error(error);
      this.searchFields = {
        make: true,
        model: true,
        year: true
      };
    }
  }

  setupEventListeners() {
    if (this.decodeButton) {
      this.decodeButton.addEventListener('click', () => this.handleDecode());
    }

    if (this.toggleSavedVinsButton) {
      this.toggleSavedVinsButton.addEventListener('click', () => this.toggleSavedVins());
    }

    if (this.imageUploadInput) {
      this.imageUploadInput.addEventListener('change', (event) => this.handleImageUpload(event));
    }

    if (this.removeImageButton) {
      this.removeImageButton.addEventListener('click', () => this.removeImage());
    }
  }

  handleImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Check file size
    if (file.size > this.MAX_IMAGE_SIZE) {
      this.showError(this.strings.errors.imageSize);
      this.imageUploadInput.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      this.imageBase64 = e.target.result;
      this.imagePreview.src = this.imageBase64;
      this.imagePreviewContainer.classList.remove('hidden');
    };

    reader.readAsDataURL(file);
  }

  removeImage() {
    this.imageBase64 = null;
    this.imageUploadInput.value = '';
    this.imagePreviewContainer.classList.add('hidden');
  }

  toggleSavedVins() {
    this.vinsListWrapper.classList.toggle('expanded');
  }

  getStorageKey() {
    return `saved_vins_${this.customer.id}`;
  }

  loadLocalVins() {
    const savedVins = localStorage.getItem(this.getStorageKey());
    return savedVins ? JSON.parse(savedVins) : [];
  }

  saveLocalVins(vins) {
    localStorage.setItem(this.getStorageKey(), JSON.stringify(vins));
    this.displaySavedVins(vins);
  }

  async syncWithServer() {
    this.setLoading(true);
    try {
      const response = await fetch('https://vin-decoder.dragos.club/client-vins?' + new URLSearchParams({
        id: this.customer.id,
        name: this.customer.name,
        email: this.customer.email
      }), {
        headers: {
          'Authorization': `Bearer ${this.apiToken}`
        }
      });

      if (!response.ok) {
        const error = new Error('HTTP error');
        error.response = response;  // Attach the response object
        throw error;
      }

      const serverVins = await response.json();
      const localVins = this.loadLocalVins();

      // Merge server and local VINs, keeping local data if available
      const mergedVins = serverVins.vins.map(serverVin => {
        const localVin = localVins.find(local => local.vin === serverVin.vin);
        return localVin || serverVin;
      });

      this.saveLocalVins(mergedVins);
    } catch (error) {
      // If server sync fails, just use local data
      const localVins = this.loadLocalVins();
      this.displaySavedVins(localVins);
    } finally {
      this.setLoading(false);
    }
  }

  displaySavedVins(vins) {
    if (!vins || vins.length === 0) {
      return;
    }

    this.savedVinsContainer.classList.remove('hidden');
    this.savedVinsList.innerHTML = vins.map(vehicle => `
      <div class="saved-vin-item">
        <div class="vehicle-info">
          <h4>${this.formatVehicleTitle(vehicle)}</h4>
          <p>VIN: ${vehicle.vin}</p>
        </div>
        <button onclick='vinDecoder.searchParts(event, ${JSON.stringify(vehicle)})'>
          ${this.strings.searchPartsLabel}
        </button>
      </div>
    `).join('');
  }

  formatVehicleTitle(vehicle) {
    const parts = [];

    // make
    if (vehicle.make) parts.push(vehicle.make);

    // model
    if (vehicle.model) parts.push(vehicle.model);

    // engine
    if (vehicle.engine) parts.push(vehicle.engine);

    // year
    if (vehicle.year) parts.push(vehicle.year);

    // trim
    if (vehicle.trim) parts.push(vehicle.trim);

    // displacement
    if (vehicle.displacement) parts.push(`${vehicle.displacement}L`);

    // fuel
    if (vehicle.fuel) parts.push(vehicle.fuel);

    // body
    if (vehicle.body) parts.push(vehicle.body);

    // seats
    if (vehicle.seats) parts.push(`${vehicle.seats} scaune`);

    // doors
    if (vehicle.doors) parts.push(`${vehicle.doors} usi`);

    // horsepower
    if (vehicle.horsepower) parts.push(`${vehicle.horsepower} CP`);

    // kilowatts
    if (vehicle.kilowatts) parts.push(`${vehicle.kilowatts} kW`);

    // driveline
    if (vehicle.driveline) parts.push(`Transmisie ${vehicle.driveline}`);

    return parts.join(' ') || this.strings.vehicleDetailsUnavailable;
  }

  async handleDecode() {
    const vin = this.vinInput.value.trim().toUpperCase();

    if (!this.validateVin(vin)) {
      return;
    }

    this.setLoading(true);
    this.decodeButton.disabled = true;

    try {
      // Prepare request payload
      const payload = {
        vin: vin,
        client: {
          id: this.customer.id,
          name: this.customer.name,
          email: this.customer.email
        }
      };

      // Add image if available
      if (this.imageBase64) {
        payload.image = this.imageBase64;
      }

      const response = await fetch('https://vin-decoder.dragos.club/decode', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.apiToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const error = new Error('HTTP error');
        error.response = response;  // Attach the response object
        throw error;
      }

      const decodedVin = await response.json();

      // Extract only the fields we care about
      const savedVehicle = {
        vin: decodedVin.vin,
        make: decodedVin.make || null,
        model: decodedVin.model || null,
        year: decodedVin.year || null,
        trim: decodedVin.trim || null,
        engine: decodedVin.engine || null,
        displacement: decodedVin.displacement || null,
        fuel: decodedVin.fuel || null,
        body: decodedVin.body || null,
        seats: decodedVin.seats || null,
        doors: decodedVin.doors || null,
        horsepower: decodedVin.horsepower || null,
        kilowatts: decodedVin.kilowatts || null,
        driveline: decodedVin.driveline || null
      };

      // Save to local storage
      const savedVins = this.loadLocalVins();
      if (savedVins.length >= 5) {
        this.showError(this.strings.errors.maxVins);
        return;
      }

      savedVins.push(savedVehicle);
      this.saveLocalVins(savedVins);

      // Reset the image input
      this.removeImage();

      // Search parts for the new vehicle
      this.searchParts(null, savedVehicle);
    } catch (error) {
      this.handleError(error);
    } finally {
      this.setLoading(false);
      this.decodeButton.disabled = false;
    }
  }

  validateVin(vin) {
    if (!vin || vin.length !== 17) {
      this.showError(this.strings.errors.invalidVin);
      return false;
    }
    return true;
  }

  searchParts(event, vehicle) {
    // Disable the clicked button
    if (event) {
      const button = event.target;
      button.disabled = true;
      // Add loading state to button
      const originalText = button.textContent;
      button.textContent = this.strings.loadingMessage;
    }


    // Add a small delay to show the loading state

    // https://nextgenpieseauto.ro/collections/all?sort_by=title-ascending&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.custom.marca=BMW&filter.p.m.custom.model=Toate+modelele&filter.p.m.custom.motorizare=Benzina&filter.p.m.custom.an_=Toti+anii

    setTimeout(() => {
      // Build search URL with only non-null parameters
      const params = new URLSearchParams();

      params.append('sort_by', 'title-ascending');

      if (this.searchFields.make) {
        params.append('filter.p.m.custom.marca', 'Toate marcile');

        if (vehicle.make) {
          params.append('filter.p.m.custom.marca', `${vehicle.make}`);
        }
      }

      if (this.searchFields.model) {
        params.append('filter.p.m.custom.model', 'Toate modelele');
        if (vehicle.model) {
          params.append('filter.p.m.custom.model', `${vehicle.model}`);
        }
      }

      if (this.searchFields.year) {
        params.append('filter.p.m.custom.an_fabricatie', 'Toti anii');
        if (vehicle.year) {
          params.append('filter.p.m.custom.an_fabricatie', `${vehicle.year}`);
        }
      }

      if (this.searchFields.body) {
        params.append('filter.p.m.custom.caroserie', 'Toate caroseriile');
        if (vehicle.body) {
          params.append('filter.p.m.custom.caroserie', `${vehicle.body}`);
        }
      }

      if (this.searchFields.trim) {
        params.append('filter.p.m.custom.varianta_caroserie', 'Toate variantele de caroserie');
        if (vehicle.trim) {
          params.append('filter.p.m.custom.varianta_caroserie', `${vehicle.trim}`);
        }
      }

      if (this.searchFields.engine) {
        params.append('filter.p.m.custom.motorizare', 'Toate motorizarile');
        if (vehicle.engine) {
          params.append('filter.p.m.custom.motorizare', `${vehicle.engine}`);
        }
      }
      if (this.searchFields.displacement) {
        params.append('filter.p.m.custom.capacitate_motor', 'Toate capacitatile motor');
        if (vehicle.displacement) {
          params.append('filter.p.m.custom.capacitate_motor', `${vehicle.displacement}`);
        }
      }

      if (this.searchFields.fuel) {
        params.append('filter.p.m.custom.combustibil', 'Toate combustibilii');
        if (vehicle.fuel) {
          params.append('filter.p.m.custom.combustibil', `${vehicle.fuel}`);
        }
      }
      if (this.searchFields.seats) {
        params.append('filter.p.m.custom.numar_locuri', 'Toate numerele de locuri');
        if (vehicle.seats) {
          params.append('filter.p.m.custom.numar_locuri', `${vehicle.seats}`);
        }
      }
      if (this.searchFields.doors) {
        params.append('filter.p.m.custom.numar_usi', 'Toate numerele de usi');
        if (vehicle.doors) {
          params.append('filter.p.m.custom.numar_usi', `${vehicle.doors}`);
        }
      }
      if (this.searchFields.horsepower) {
        params.append('filter.p.m.custom.putere_cp', 'Toate puterile');
        if (vehicle.horsepower) {
          params.append('filter.p.m.custom.putere_cp', `${vehicle.horsepower}`);
        }
      }
      if (this.searchFields.kilowatts) {
        params.append('filter.p.m.custom.putere_kw', 'Toate puterile');
        if (vehicle.kilowatts) {
          params.append('filter.p.m.custom.putere_kw', `${vehicle.kilowatts}`);
        }
      }
      if (this.searchFields.driveline) {
        params.append('filter.p.m.custom.transmisie', 'Toate transmisiile');
        if (vehicle.driveline) {
          params.append('filter.p.m.custom.transmisie', `${vehicle.driveline}`);
        }
      }

      // Make (marca)
      // Model (model)
      // Engine (motorizare)
      // Year (an_)
      // Body (caroserie)
      // Trim (varianta_caroserie)
      // Displacement (capacitate_motor)
      // Fuel (combustibil)
      // Seats (locuri)
      // Doors (usi)
      // Horsepower (putere_cp)
      // Kilowatts (putere_kw)
      // Driveline (transmisie)

      window.location.href = `/collections/all?${params.toString()}`;
    }, 300);
  }

  handleError(error) {
    let message = this.strings.errors.unknown;

    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = this.strings.errors.maxVins;
          break;
        case 401:
          message = this.strings.errors.auth;
          break;
        case 422:
          message = this.strings.errors.decode;
          break;
      }
    }

    this.showError(message);
  }

  showError(message) {
    this.errorMessage.textContent = message;
    this.errorMessage.classList.remove('hidden');
    setTimeout(() => {
      this.errorMessage.classList.add('hidden');
    }, 5000);
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.loadingMessage.querySelector('span').textContent = this.strings.loadingMessage;
      this.loadingMessage.classList.remove('hidden');
    } else {
      this.loadingMessage.classList.add('hidden');
    }
  }
}


window.vinDecoder = new VinDecoder();


  } catch(e) { console.error(e); }
})();
})();
